module.exports = __webpack_public_path__ + "static/img/app-store.ffe30797.png";